export const MEETING_REQUEST = 'MEETING_REQUEST'
export const MEETING_SUCCESS = 'MEETING_SUCCESS'
export const MEETING_FAILURE = 'MEETING_FAILURE'